import axios from "axios";
import React, { useState, useContext } from "react";
import { Button, Heading } from "blueprints2";

import CreateCredential from "./forms/CreateCredential";
import { CredentialContext } from "../context/CredentialContext";
import { isUnique,isLengthValid } from "../helpers";
import CredentialAlert, { AlertTypes } from "./CredentialAlert";
import { FormattedMessage, injectIntl } from "react-intl";

function ApplicationsHeading({ intl, workspace }) {
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [error, setError] = useState("");
  const [appName, setAppName] = useState("");
  const [alert, setAlert] = useState(null);
  const { credentialState, updateCredentials } = useContext(CredentialContext);
  const credentialsUrl = "/" + workspace + "/credentials/oauth2";
  const [isCredentialPosting, setIsCredentialPosting] = useState(false);

  const createCred = (e) => {
    // prevent submit & validate input
    e.preventDefault();

    if (!isLengthValid(appName, credentialState)) {
      setError(intl.formatMessage({ id: "applications.form.error.size" }));
      return;
    }

    if (!isUnique(appName, credentialState)) {
      setError(intl.formatMessage({ id: "applications.form.error.unique" }));
      return;
    }
    
    setIsCredentialPosting(true);

    axios({
      method: "post",
      url: credentialsUrl,
      withCredentials: true,
      data: {
        name: appName,
        redirect_uris: [process.env.REACT_APP_DEFAULT_REDIRECT],
      },
    })
      .then(() => {
        // hide modal & get new data
        setCreateModalVisible(false);
        return axios.get(credentialsUrl, { withCredentials: true });
      })
      // update credentialData context & alert user
      .then((res) => {
        const credentialData = res.data.data;
        updateCredentials(credentialData);
        const extraData = {
          appName,
        };
        setAlert({ type: AlertTypes.ADD, extraData });
      })

      // catch errs from post or get
      .catch((e) => {
        setCreateModalVisible(false);
        setAlert({ type: AlertTypes.ERROR });
      });
  };

  const formChange = (e) => {
    let name = e.value;
    setAppName(name);
  };

  return (
    <div className="react_page__component">
      <Heading level={2}>
        <FormattedMessage id="applications.title" />
      </Heading>
      <div className="border-b border-gray-400"></div>
      <div className="flex flex-col">
        {/* Heading */}
        <div className="w-full mt-4 flex justify-between">
          <Heading level={3}>
            <FormattedMessage id="applications.credentials.heading" />
          </Heading>

          <Button
            icon="add-outline"
            onClick={() => {
              setCreateModalVisible(true);
              setIsCredentialPosting(false); 
            }}
          >
            <FormattedMessage id="applications.add" />
          </Button>
        </div>

        <CredentialAlert className="create_alert" {...alert} />

        <CreateCredential
          visible={createModalVisible}
          setVisible={setCreateModalVisible}
          change={formChange}
          createCred={createCred}
          error={error}
          isCredentialPosting={isCredentialPosting}
        />
      </div>
    </div>
  );
}

export default injectIntl(ApplicationsHeading);
